import { KForm, KPasswordField, KTextField, KLink } from "kinnect-general";

export default KForm.extend( {
	name: "KLoginForm",

	props: {
		cancelButtonText: {
			...KForm.options.props.cancelButtonText,
			default: false
		},

		formTitle: {
			...KForm.options.props.formTitle,
			default: "Log In"
		},

		submitButtonText: {
			...KForm.options.props.submitButtonText,
			default: "Log In"
		},

		successMessage: {
			...KForm.options.props.successMessage,
			default: false
		}
	},

	data: () => ( {
		formFields: {
			firstName: null,
			lastName: null,
			password: null
		},
		fullName: ""
	} ),

	watch: {
		fullName: {
			handler( fullName ) {
				if ( fullName ) {
					const splitName = fullName.trim().split( " " );

					this.formFields.firstName = splitName[0];
					this.formFields.lastName = splitName[1];
				} else {
					this.formFields.firstName = null;
					this.formFields.lastName = null;
				}
			},
			immediate: true
		}
	},

	methods: {
		submit() {
			return this.$store.dispatch( "auth/login", this.formFields );
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				manualSubmitCall: this.submit
			}}
		>
			<KTextField
				label="First and Last Name*"
				prependIcon="person"
				required
				vModel={this.fullName}
				validationName="name"
				validationRules="required|alpha_spaces|numberOfWords:2"
			></KTextField>

			<KPasswordField
				label="Password*"
				prependIcon="lock"
				required
				vModel={this.formFields.password}
				validationName="password"
				validationRules="required"
			></KPasswordField>

			<KLink
				block
				to={{ name: "forgotPassword" }}
			>Forgot Password?</KLink>
		</KForm>;
	}
} );
